import React from 'react';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import {Props} from './FormField';
import RequiredFieldSign from './RequiredFieldSign';
import {Label} from 'reactstrap';
import FormLinkToRelationFormPage from './LinkToRelationFormPage';

export default function FormFieldLabel<Model extends IEmptyModel>(props: {
    labelId: string,
    labelText: string,
    children?: React.ReactNode,
} & Props<Model>) {
    const {labelId, labelText, renderLabelContent} = props;

    return <Label htmlFor={labelId}>
        {renderLabelContent ? renderLabelContent(props) : (
                <FormLinkToRelationFormPage {...props}>
                    <RequiredFieldSign {...props.config}>
                        {labelText}
                    </RequiredFieldSign>
                </FormLinkToRelationFormPage>
        )}

        {props.children}
    </Label>;
}
